<div a-context-popup [title]="'Collections'"
     (close)="onAssignCollectionAndClosePopup()"
>
  <right-menu-collections-list
    [collections]="collections"
    [selectedCollections]="boardCollections">
  </right-menu-collections-list>
</div>
